import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import Form from 'core/forms/Form';
import Field from 'core/forms/Field';
import RecaptchaField from 'common/components/fields/RecaptchaField';

import Button from 'common/components/Button';

import { localeStrings as strings } from 'applicationConfig';

import InputTextField from 'common/components/fields/InputTextField';
import { InputValidator, PasswordValidationRule } from 'core/validation';
import { withRouter } from 'react-router';

@inject('settingsStore')
@inject('userStore')
@observer
class ChangePasswordForm extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  onFormSubmit(values) {
    this.props.userStore
      .changePassword(values.currentPassword, values.newPassword)
      .catch((e) => {
        this.props.formStore.resetCaptcha();
        throw e;
      })
      .then((result) => {
        this.props.settingsStore.showSimpleAlert(strings.myAccount.changeSuccess);
      });
  }

  onPasswordConfirmationPaste(e) {
    e.preventDefault();

    return false;
  }

  render() {
    const defaultValidationRule = new PasswordValidationRule(strings.generic.errorMessages.passwordTooWeek, 8);

    return (
      <div className="change-password">
        <Form onSubmit={this.onFormSubmit.bind(this)} formStore={this.props.formStore}>
          <div className="field-group required-field-group">
            <label className="field-group-label">{strings.changePassword.currentPassword}</label>

            <div className="field-group-value">
              <Field component={InputTextField} type="password" name="currentPassword">
                <InputValidator>{[ defaultValidationRule ]}</InputValidator>
              </Field>
            </div>
          </div>

          <div className="field-group required-field-group">
            <label className="field-group-label">{strings.changePassword.newPassword}</label>

            <div className="field-group-value">
              <Field component={InputTextField} type="password" name="newPassword">
                <InputValidator>{[ defaultValidationRule ]}</InputValidator>
              </Field>
            </div>
          </div>

          <div className="field-group required-field-group">
            <label className="field-group-label">{strings.changePassword.newPasswordConfirmed}</label>

            <div className="field-group-value">
              <Field
                component={InputTextField}
                type="password"
                onPaste={this.onPasswordConfirmationPaste}
                name="newPasswordConfirmation"
              >
                <InputValidator>{[ defaultValidationRule ]}</InputValidator>
              </Field>
            </div>
          </div>

          <div>
            <div className="field-group captcha-field-group">
              <Field component={RecaptchaField} name="captchaVerified" />
            </div>
          </div>

          <div className="field-group-actions">
            <div className="actions">
              <Button
                className="btn btn-primary"
                type="submit"
                disabled={!this.props.formStore.isValid || this.props.formStore.isFormSubmitted}
              >
                <span className="button-caption">{strings.generic.submit}</span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

ChangePasswordForm = withRouter(ChangePasswordForm);

export { ChangePasswordForm };



// WEBPACK FOOTER //
// ./src/containers/MyAccount/ChangePassword/ChangePasswordForm.jsx